import { useMutation } from '@tanstack/react-query'

import { putTransactionEvidenceEmailsLinkToTransaction } from '@src/api'
import { DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePutTransactionEvidenceEmailsLinkToTransaction = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiPutTransactionEvidenceEmailsLinkToTransactionRequest
    ) => putTransactionEvidenceEmailsLinkToTransaction(axiosInstance, params),
  })
}
